<template>
    <div class="container">

            <div class="page-top mb-1 mb-3 align-center clearfix">
                <h1 class="float-left">{{shiftName}} shift:{{heading}}<span v-if="plurrerHeading">(s)</span> </h1>
            </div>
            <div class="shift-mangement-top-box mb-3">
              
            <table id="newshiftsrequest" class="table table-responsive-xl" style="width:100%">
                <thead>
                <tr>
                    <th>Name</th>
                    <th >Action</th>
                </tr>
                </thead>
                <tbody>
                  <tr v-for="record in records">
                        <td>{{record.name}}</td>
                        <td>
                           <router-link v-bind:to="'/shiftDetailUsers/'+heading+'/'+record.id+'/'+shiftId"  class="btn btn-primary"><i class="fas fa-eye"></i></router-link>
                           <button class="btn btn-primary"  @click="deletedata(record.id)"><i class="fas fa-trash"></i></button>
                        </td>
                  </tr>
               </tbody>
            </table>
        </div>
</div>
</template>
<script>
    export default {
        data(){
            return{
              records:[],
              heading:'',
              plurrerHeading:false,
              shiftId:this.$route.params['shiftId'],
              shiftName:'',
            }
        },
        methods:{
           
            getList(){
                 this.$Progress.start();
                 let self=this;
                axios.get('/api/getDetail/'+self.heading+'/'+this.$route.params['shiftId'])
                .then(res => {
                        self.records=res.data.data;
                        if(self.records.length>1){
                            self.plurrerHeading=true;
                        }
                        self.shiftName=res.data.shiftName;
                        self.$Progress.finish();
                        setTimeout(function(){ $('#newshiftsrequest').DataTable() }, 0);
                }).catch(err => {
                    self.$Progress.fail();
                    self.showAlertBox('error','Something went wrong!');
                });
            },
             deletedata(id){
                 this.$Progress.start();
                 let self=this;
                axios.get('/api/deleteData/'+self.heading+'/'+id+'/'+this.$route.params['shiftId'])
                .then(res => {
                    self.showAlertBox('success',self.heading+' deleted successfully!');
                    location.reload()

                }).catch(err => {
                    self.$Progress.fail();
                    self.showAlertBox('error','Something went wrong!');
                });
            }
        },
        mounted(){
             this.heading=this.$route.params['requestFor'].replace(/^(.)|\s+(.)/g, c => c.toUpperCase())

              this.getList();
        }
    }
</script>